<template>
  <div class="baidu-map-list-template">
    <el-tabs v-model="activeName" class="tabs">
      <el-tab-pane label="司法拍卖" name="justice">
        <justiceList
          ref="justiceList"
          :address="address"
          @on-update-list="updateJusticeList"
          @on-show-detail="showDetail"
        />
      </el-tab-pane>
      <el-tab-pane label="房产成交" name="estate">
        <estateList
          ref="estateList"
          :address="address"
          @on-update-list="updateEstateList"
          @on-show-detail="showDetail"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import listMixin from "@/mixins/list";
import justiceList from "./components/justice-list";
import estateList from "./components/estate-list";

export default {
  mixins: [listMixin],
  components: { justiceList, estateList },
  props: {
    // 地址
    address: {
      default: ""
    }
  },
  data() {
    return {
      // 选项卡
      activeName: "justice",
      initCfg: {
        listApi: ""
      },
      query: {
        keyword: ""
      },
      data: [],
      // 是否是列表状态
      isListStatus: true
    };
  },
  watch: {
    // apiUrl: {
    //   immediate: true,
    //   handler(val) {
    //     if (val) {
    //       this.initCfg.listApi = val;
    //       this.search();
    //     }
    //   }
    // },
    // address: {
    //   immediate: true,
    //   handler(val) {
    //     if (!this.initCfg.listApi) return;
    //     this.query.keyword = val;
    //     this.search();
    //   }
    // },
    // 获取不同选项卡的当前列表数据
    activeName(val) {
      let name = [];
      if (val === "justice") {
        name = "justiceList";
      } else if (val === "estate") {
        name = "estateList";
      }

      if (this.$refs[name]) {
        this.$emit("on-update-list", this.$refs[name].getCurrListData());
      }
    }
  },
  methods: {
    // 获取列表数据
    search(address) {
      this.$refs.justiceList.search(address);
      this.$refs.estateList.search(address);
    },

    // 获取详情
    showDetail({ type, id }) {
      this.$emit("on-show-detail", { type, id });
    },

    updateJusticeList(list) {
      if (this.activeName === "justice") {
        this.$emit("on-update-list", list);
      }
    },

    updateEstateList(list) {
      if (this.activeName === "estate") {
        this.$emit("on-update-list", list);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
